// extracted by mini-css-extract-plugin
export default {"container":"ur-sm","small":"+h-Uu","medium":"RIbbk","footerPost":"+tLee","search":"QZcyQ","hashtags":"_4GrB7"};